import React, { useState, useEffect, useRef, useContext } from 'react';
import { LanguageSelectorStyles as styles } from '../css/styles';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { FaGlobe } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';
import MobileModal from './MobileModal';
import classNames from 'classnames';

interface LanguageSelectorProps {
  appearance?: 'icon' | 'dropdown';
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ appearance = 'dropdown' }) => {

  const { currentUser } = useContext(AuthContext);
  const { i18n } = useTranslation();
  const { language, changeLanguage, changeUserLanguage } = useLanguage();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangeLanguage = (newLanguage: string) => {
    if (currentUser && currentUser.userId && appearance === 'dropdown') {
      changeUserLanguage(newLanguage, currentUser.userId);
    } else {
      changeLanguage(newLanguage);
    }

    i18n.changeLanguage(newLanguage);
    setShowDropdown(false);
  }

  const handleOutsideClick = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowDropdown(false);
    }
  }

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick)
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick)
    };
  }, [showDropdown])


  if (isMobile) {
    return (
      <>
        <button className={styles.languageButton} onClick={() => setShowDropdown(true)}>
          <FaGlobe className={styles.image} />
          {/* {languageMap[language] || language} */}
        </button>
  
        <MobileModal isOpen={showDropdown} onClose={() => setShowDropdown(false)} header={"Select Language"}>
          <div className="language-selector-mobile-buttons">
            <button className="global-button" onClick={() => handleChangeLanguage("en")}>English</button>
            <button className="global-button" onClick={() => handleChangeLanguage("ru")}>Русский</button>
            <button className="global-button" onClick={() => handleChangeLanguage("es")}>Español</button>
          </div>
        </MobileModal>
      </>
    );
  }

  if (appearance === 'icon') {
    return (
      <div ref={dropdownRef}>
        <FaGlobe className={styles.image} onClick={() => setShowDropdown(!showDropdown)} />
        {showDropdown && (
          <div className={classNames(styles.dropdownMenu, {[styles.dropdownMenuShow] : showDropdown})}>
            <button onClick={() => handleChangeLanguage('en')}>English</button>
            <button onClick={() => handleChangeLanguage('ru')}>Русский</button>
            <button onClick={() => handleChangeLanguage('es')}>Español</button>

          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <select className={styles.selectLanguage} value={language} onChange={(e) => handleChangeLanguage(e.target.value)} name="studentLanguage">
        <option value="en">English</option>
        <option value="ru">Русский</option>
        <option value="es">Español</option>
      </select>
    </div>
  )
}
export default LanguageSelector